import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { shouldDisplayCookieWall } from '@app/helper/cookie-wall';

import Analytics from '@module/analytics';
import I18n from '@module/i18n';

import Icon from '@component/icon';
import Button from '@component/form/element/button';

import { WHITE, DODGER_BLUE } from '@constant/colors';

import Actions from '@app/store/action';

export const WelcomeNotice = ({
  acceptTermsAndConditions,
  closePanel,
  user,
  session,
}) => {
  useEffect(() => {
    Analytics.trackSnowplowEvent({
      category: 'transfer',
      action: 'show_terms_and_cookie',
      label: 'i_agree',
    });
  }, []);

  const handleAgree = () => {
    acceptTermsAndConditions();
    closePanel();
  };

  const content = shouldDisplayCookieWall({ user, session })
    ? {
        __html: I18n.t('transfer.terms_conditions-no-cookies.text', {
          options: 'data-route-type="plus"',
        }),
      }
    : {
        __html: I18n.t('transfer.terms_conditions.text', {
          options: 'data-route-type="plus"',
        }),
      };

  return (
    <React.Fragment>
      <div className="welcome__title">
        {I18n.t('welcome.title')}
        <svg viewBox="0 0 500 72">
          <path
            fill={DODGER_BLUE}
            d="M99.5 2.9v.5C95 4.7 93.2 7.2 90 15L66.6 71.5h-.4L49.7 31.7 33.2 71.5h-.4l-24-57.9C7 8.9 4.8 4.4 0 3.4v-.5h33.3v.5c-2 .8-3.3 2.2-3.3 4.9 0 1.7.5 4.1 1.7 7.1l10.4 25.1 5.6-13.3-5.6-13.5c-1.8-4.5-2.9-6.4-4.5-10.2v-.6H70v.5C66.6 4 63.9 6 63.9 10c0 1.5.4 3.3 1.3 5.4l10.4 25.2 10.5-25.2c.9-2 1.2-3.8 1.2-5.3 0-3.9-2.3-6.1-5.1-6.7v-.5h17.3zM131.9 52.5l.8.2C130.1 67.6 120 72 112.3 72c-11.1 0-22-8.9-22-25.8 0-16.2 9.6-27.8 22.7-27.8 8.2 0 19.9 4.4 19.9 22.7h-27.8c1.4 10.9 7.2 16.5 15.9 16.5 4.7 0 8.3-1.4 10.9-5.1zm-27.2-17.1c0 1 0 1.8.1 2.7h12c0-12.8-2-16.5-5.9-16.5-4 0-6.2 5.1-6.2 13.8zM191 0v27.5h-.5c-1.7-9.6-8-20.9-16.7-20.9h-1v53c0 6.3 2.5 9.3 9.1 10.4v.5h-38.5V70c6.6-1.2 9.1-4.2 9.1-10.4v-53h-1c-8.7 0-15 11.3-16.7 20.9h-.5V0h.5c1.9 2.2 5.3 2.9 8.6 2.9h38.5c3.3 0 6.7-.7 8.6-2.9h.5zM231.6 18.4v17.5h-.5c-1.3-.8-2.7-1.2-5.7-1.2-6.2 0-10.3 2.9-10.3 15.4v12.8c0 4.7 3.1 6.5 6.7 7.2v.5H192v-.5c2.7-1.2 4.7-3.3 4.7-7.2V34.4c0-5.2-1.4-7.8-4.7-8.9V25l22.3-6.7v23.8h.6c.7-17.4 7-23.8 15.3-23.8h1.4zM285.4 58.5C283.8 67.7 277.6 72 270 72c-6.8 0-10.7-3.4-11.7-8.7l-.3-.1c-1.5 5-6 8.8-12.9 8.8-8 0-12.7-6-12.7-12.5 0-8.8 7.3-14.8 18.8-17.2l6.4-1.4v-1.6c0-6.1-2.1-11.4-10.1-11.4-6 0-10.1 2.3-12.6 9.7l-.7-.2c1.6-11.8 9.4-19 21.8-19 14.2 0 20 9.2 20 22.1v17c0 3.4 1.7 4.8 3.7 4.8 1.5 0 3.8-.8 4.6-4l1.1.2zm-27.6 2.8V43.9l-1.4.3c-5.5 1.1-7.3 5.1-7.3 10.2 0 4.9 2.4 7.9 6 7.9 1.2 0 2.1-.2 2.7-1z"
          />
          <path
            fill={DODGER_BLUE}
            d="M340.3 70.1v.5h-25.9v-.5c2-1 2.8-2.8 2.8-6.3V32.4c0-4-1.6-5.9-4.4-5.9-2.2 0-3.7 1-4.7 2.4v34.9c0 3.5.8 5.3 2.8 6.3v.5H285v-.5c2.7-1.2 4.7-3.3 4.7-7.2V33.2c0-4.6-1.3-6.7-4.7-7.7V25l23.1-6.6v8.8c2.1-5.7 7.1-8.8 13.5-8.8 8.8 0 14 5 14 14v30.4c0 4 2 6.1 4.7 7.3zM341.3 65.1l5.8-13.1.6.1c2.4 8.5 9.2 15.6 16.6 15.6 5.4 0 7-3 7-5.4 0-2.1-1.1-3.9-3.4-4.8l-15-7c-7-3.3-9.5-8.5-9.5-14.3 0-7.9 6.3-17.9 21.7-17.9 6.2 0 12.7 1.7 17.9 5.6l-6 11.2-.6-.1c-3.9-10.5-10.5-12.9-15.2-12.9-4.6 0-6.4 2-6.4 4.4 0 2 1.3 4.1 4.1 5.4l14.2 6.6c6.4 3 9 7.8 9 13.6 0 9.8-6.9 19.7-21.4 19.7-7.4.2-14.4-2.6-19.4-6.7zM422.1 5.3l-7.4 9.7-.5-.1c-.6-7-4.6-10-8.8-10-4.7 0-6.6 3.9-6.6 6.3 0 2.8.9 7.2 6.5 8.6h8.4v2.4h-6.2v40.6c0 4.7 3.1 6.5 6.7 7.2v.5h-29.8V70c2.7-1.2 4.7-3.3 4.7-7.2V22.2h-4.7v-2.4h4.7v-.4c0-11.5 6.8-18.5 18.5-18.5 7 .1 10.9 1.9 14.5 4.4z"
          />
          <path
            fill={DODGER_BLUE}
            d="M457 52.5l.8.2C455.2 67.6 445.1 72 437.4 72c-11.1 0-22-8.9-22-25.8 0-16.2 9.6-27.8 22.7-27.8 8.2 0 19.9 4.4 19.9 22.7h-27.8c1.4 10.9 7.2 16.5 15.9 16.5 4.7 0 8.3-1.4 10.9-5.1zm-27.3-17.1c0 1 0 1.8.1 2.7h12c0-12.8-2-16.5-5.9-16.5-3.9 0-6.2 5.1-6.2 13.8zM500 18.4v17.5h-.5c-1.3-.8-2.7-1.2-5.7-1.2-6.2 0-10.3 2.9-10.3 15.4v12.8c0 4.7 3.1 6.5 6.7 7.2v.5h-29.8v-.5c2.7-1.2 4.7-3.3 4.7-7.2V34.4c0-5.2-1.4-7.8-4.7-8.9V25l22.3-6.7v23.8h.6c.7-17.4 7-23.8 15.3-23.8h1.4z"
          />
        </svg>
      </div>
      <div className="welcome__perks">
        <ul className="plan__features">
          <li>
            <Icon type="Valid" color={WHITE} />{' '}
            {I18n.t('welcome.plan.free.feature_1')}
          </li>
          <li>
            <Icon type="Valid" color={WHITE} />{' '}
            {I18n.t('welcome.plan.free.feature_2')}
          </li>
          <li>
            <Icon type="Valid" color={WHITE} />{' '}
            {I18n.t('welcome.plan.free.feature_3')}
          </li>
        </ul>
      </div>
      <div className="welcome__terms">
        <p dangerouslySetInnerHTML={content} />
      </div>
      <div className="welcome__buttons">
        <Button
          text={I18n.t('transfer.terms_conditions.button')}
          className="welcome__agree"
          onClick={handleAgree}
        />
      </div>
    </React.Fragment>
  );
};

WelcomeNotice.propTypes = {
  user: PropTypes.object.isRequired,
  session: PropTypes.object.isRequired,
  acceptTermsAndConditions: PropTypes.func.isRequired,
  closePanel: PropTypes.func.isRequired,
};

const mapStateToProps = ({ user, session }) => ({ user, session });

export const mapDispatchToProps = (dispatch) => ({
  acceptTermsAndConditions: () => {
    dispatch(Actions.Session.acceptTermsConditions());

    Analytics.trackSnowplowEvent({
      category: 'transfer',
      action: 'click_give_consent',
      label: 'i_agree',
    });
  },
});

const ConnectedWelcomeNotice = connect(
  mapStateToProps,
  mapDispatchToProps
)(WelcomeNotice);

ConnectedWelcomeNotice.propTypes = {
  closePanel: PropTypes.func.isRequired,
};

export default ConnectedWelcomeNotice;
